import Routes from '../url/urlRoutes'
import CustomerTypes, {CustomerTypesUrl} from './customerTypes'

export default function getCustomerTypeFromUrl(
    location?: {pathname: string} | null
): CustomerTypes {
    if (
        !location ||
        typeof location === 'undefined' ||
        !location.pathname.length
    ) {
        return CustomerTypes.PRIVATE
    }

    const URL_SEPARATOR = '/'
    const CUSTOMER_URL_INDEX = 0
    const customerTypeFromUrl = location.pathname
        .replace(`/${Routes.CUSTOMER_TYPE}/`, '')
        .split(URL_SEPARATOR)[CUSTOMER_URL_INDEX]

    // eslint-disable-next-line security/detect-object-injection
    return customerTypeFromUrl === CustomerTypesUrl.PR
        ? CustomerTypes.PRIVATE
        : CustomerTypes.BUSINESS
}
